import React, { useState } from "react";
import { Button, Stack, styled, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SheetContainer } from "../../../../../styles/common";
import Help from "@shared/help";
import { AssociatedCustomerDataList } from "store/slices/validatePAN";

const DrawerBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing(2)};
  row-gap: 6px;
  color: #333333;
`;

interface PanDiffAccProps {
  panAction?: (actionType: "CONTINUE" | "RESET") => void;
}

function PanDiffAcc({ panAction }: PanDiffAccProps) {
  const { t } = useTranslation();
  const info = useSelector((state: any) => state.info.allData);
  const panValidation = useSelector((state: any) => state.pan);

  const [isHelpOpen, setIsHelpOpen] = useState<boolean>(false);
  return (
    <>
      <SheetContainer open={true} anchor="bottom">
        <DrawerBody>
          <Typography variant="h2">
            {t("pan_already_linked_message", {
              defaultValue:
                "This PAN is already linked to below Customer IDs:",
            })}
          </Typography>
          <table>
            {(
              (panValidation?.panResponse
                ?.associatedCustomerDataList as AssociatedCustomerDataList[]) ||
              []
            ).map((item) => (
              <tr key={item.customerId}>
                <td style={{ whiteSpace: "nowrap", verticalAlign: "top" }}>
                  <Typography color="primary">{"Customer ID: "}</Typography>
                </td>
                <td>
                  <Typography color="primary">
                    {`${item.customerId} (${item.shopName})`}
                  </Typography>
                </td>
              </tr>
            ))}
          </table>

          <Typography sx={{ pt: 1.5 }} color="#666666">
            <Trans
              i18nKey={"continue_same_pan_message"}
              values={{
                customerId: info?.customerId,
              }}
              components={{
                mark: (
                  <Typography
                    component={"span"}
                    color="#000000"
                    fontWeight={600}
                  />
                ),
              }}
            />
          </Typography>
          <Typography sx={{ pb: 2 }} color="primary">
            {`${t("firm_name", {
              defaultValue: "Firm Name",
            })}: ${info?.shopName}`}
            {}
          </Typography>
          <Stack spacing={2} width="100%">
            {/* <Button
              variant="contained"
              size="large"
              onClick={() => panAction?.("CONTINUE")}
            >
              {t("use_same_pan", { defaultValue: "Use Same PAN" })}
            </Button> */}
            <Button
              variant="outlined"
              size="large"
              onClick={() => panAction?.("RESET")}
            >
              {t("enter_different_pan", {
                defaultValue: "Enter a Different PAN",
              })}
            </Button>
            <Button
              variant="text"
              size="large"
              onClick={() => setIsHelpOpen(true)}
            >
              {t("contact_support", { defaultValue: "Contact Support" })}
            </Button>
          </Stack>
        </DrawerBody>
      </SheetContainer>
      <Help open={isHelpOpen} close={setIsHelpOpen} />
    </>
  );
}

export default PanDiffAcc;
